// importer toutes les images dans le dossier assets
import ImagePair from "@front-apps/core/models/imagePair"
import skiLandingScape from "../assets/img/ski-landscape-welcome.png"
import infoWhite from "../assets/img/infos-white.png"
import tribeWhite from "../assets/img/tribe-white.png"
import qrWhite from "../assets/img/qr-white.png"
import infoPurple from "../assets/img/infos-purple.png"
import tribePurple from "../assets/img/tribe-purple.png"

/**
 *ImageMap tableau de ImagePair qui va contenir toutes les images avec leurs keys
 */
export const imageMap: Array<ImagePair> = [
    {
        key: "ski-landscape-welcome",
        import: skiLandingScape,
    },
    {
        key: "qr-white",
        import: qrWhite,
    },
    {
        key: "tribe-white",
        import: tribeWhite,
    },
    {
        key: "info-white",
        import: infoWhite,
    },
    {
        key: "info-purple",
        import: infoPurple,
    },
    {
        key: "tribe-purple",
        import: tribePurple,
    },
]
